import { createValidationSchema } from "../../../../utils";

const commonValidation = [
  {
    key: "firstName",
    type: "text",
  },
  {
    key: "lastName",
    type: "text",
  },
  {
    key: "dob",
    type: "text",
  },
  {
    key: "gender",
    type: "text",
  },
];

export const orgEditValidation = createValidationSchema([
  ...commonValidation,
  {
    key: "groupIds",
    type: "arrayString",
  },
]);

export const groupEditValidation = createValidationSchema(commonValidation);
